import { FormlyFieldConfig } from '@ngx-formly/core';
import { Subject } from 'rxjs';

type ApplyValueToAllConfigurationsCommand = {
  orderInfo: { orderId: string; orderItemId: number; selectedConfigIndex: number };
  key: FormlyFieldConfig['key'];
  value: unknown;
};

export abstract class OrdersServiceWithApplyToAll {
  applyValueToAllConfigurationsFromOrder$ = new Subject<ApplyValueToAllConfigurationsCommand>();
}
